import { useQuery } from "@apollo/client";

import { useSalonStore } from "@/lib/store/salon";

import { GET_DISCOUNT_ANALYTICS } from "../graphql/discount-analytics-queries";
import { formatReportDate } from "../lib/report-date-range";
import { useReportsV2Store } from "../store/use-reports-v2-store";

export function useDiscountAnalyticsData() {
  const { currentSalon } = useSalonStore();
  const { currentPeriod, comparisonPeriod, discountScope } = useReportsV2Store();

  const baseFilters = {
    salonId: currentSalon?.id,
    period: "CUSTOM" as const,
    scope: discountScope,
    timezone: currentSalon?.timezone || "UTC",
    includeComparison: false,
  };

  const currentQuery = useQuery(GET_DISCOUNT_ANALYTICS, {
    variables: {
      filters: {
        ...baseFilters,
        startDate: currentPeriod
          ? formatReportDate(currentPeriod.startDate, currentSalon?.timezone || "UTC")
          : undefined,
        endDate: currentPeriod
          ? formatReportDate(currentPeriod.endDate, currentSalon?.timezone || "UTC")
          : undefined,
      },
    },
    skip: !currentSalon || !currentSalon.timezone || !currentPeriod,
  });

  const comparisonQuery = useQuery(GET_DISCOUNT_ANALYTICS, {
    variables: {
      filters: {
        ...baseFilters,
        startDate: comparisonPeriod
          ? formatReportDate(comparisonPeriod.startDate, currentSalon?.timezone || "UTC")
          : undefined,
        endDate: comparisonPeriod
          ? formatReportDate(comparisonPeriod.endDate, currentSalon?.timezone || "UTC")
          : undefined,
      },
    },
    skip: !currentSalon || !currentSalon.timezone || !comparisonPeriod,
  });

  return {
    data: currentQuery.data?.discountAnalyticsReport ?? null,
    comparison: comparisonQuery.data?.discountAnalyticsReport ?? null,
    loading: currentQuery.loading || comparisonQuery.loading,
    error: currentQuery.error || comparisonQuery.error,
    refetch: currentQuery.refetch,
  };
}
